import RockLee from './RockLee';
import FireFighter from './FireFighter';

let Characters = () => {
  return {
    // RockLee,
    FireFighter,
  }
}

export default Characters;